<template>
  <base-container ref="container" :isLoading="isLoading">
    <ArtisanGrid
    ref="dept"
    metaKey="BasisDeptInfo"
    :leftOption="leftOption"
    :metaInited="metaInited"
    @SyncDept="syncDept"
    isTree
    defaultExpandAll
    >
      <template #isValid="{ row }">
        <el-switch
        v-model="row.isValid"
        active-color="#13ce66"
        @change="change(row)"
        ></el-switch>
      </template>
      <template #sortNo="{ row }">
        <el-input-number
        style="width: 100%"
        v-model="row.sortNo"
        :controls="false"
        :min="0"
        size="mini"
        @change="change(row)"
        ></el-input-number>
      </template>
    </ArtisanGrid>
  </base-container>
</template>

<script>
  import {editDept, syncDept} from "@/api/basis/dept";
import {syncDoctor} from "@/api/basis/doctor";
export default {
  data() {
    return {
      isLoading: false,
      leftOption: {
        width: "20%",
        title: "院区",
        treeKey: "BasisHospitalInfo",
        searchField: "hosId",
      },
    };
  },
  methods: {
    syncDept() {
      this.$refs.container.confirm({ msg: "确认同步科室信息？" }).then(() => {
        this.isLoading = true;
        syncDept()
          .then(() => {
            this.isLoading = false;
            this.$message({
              type: "success",
              message: "同步成功！",
            });
            this.$refs.dept.reload();
          })
          .catch(() => {
            this.isLoading = false;
          });
      });
    },
    change(row) {
      editDept(row).then((res) => {});
    },
  },
};
</script>

<style>
</style>
